import React from 'react';
import _ from 'lodash';

import RouteItem from './RouteItem';

import { BackToRoutes } from './CycleRoutes';

const RouteList = ({ area, regions, singleRoute, routeType, hidePolylines, initPolyLines }) => {
	let previousPage = `${ area }`;

	if (singleRoute && area === 'regional') {
		previousPage = `${ area }/${ regions.join(',') }`;
	}
	return (
		<div className="cycling-route__list">

			{ singleRoute &&
				<BackToRoutes singleRoute={ singleRoute } regions={ regions } backParam={ previousPage } />
			}

			<ul className={ `routes-list ${ singleRoute ? 'single-filtered' : '' }` }>

				{ routeType.length > 0 &&
					routeType.map((route, i) => (
						<RouteItem
							route={ route }
							key={ i }
							area={ area }
							singleRoute={ singleRoute }
							hidePolylines={ hidePolylines }
							initPolyLines={ initPolyLines }
						/>
					))
				}

				{ routeType.length === 0 &&
					<p>There aren't any routes that meet all of the above filter selections.</p>
				}

			</ul>
		</div>
	)
}

export default RouteList;



// WEBPACK FOOTER //
// ./src/components/RouteList.js